import { z } from 'zod';
import { apiClient } from '#/api/client';
import {
  MessageTemplateMetaSchema,
  MessageTemplateMeta,
} from '#/components/ui/messages/model';
import {
  MESSAGE_TEMPLATE_ENDPOINT_BASE,
  MESSAGE_QUERY_KEY_NAMESPACE,
} from './utils';
import { useQuery } from '@tanstack/react-query';

async function fetchMessageTemplateMeta() {
  const response = await apiClient.get<{ data: MessageTemplateMeta }>(
    `${MESSAGE_TEMPLATE_ENDPOINT_BASE}/meta`,
  );

  return response.data.data;
}

export function useMessageCategories() {
  const query = useQuery({
    queryKey: [MESSAGE_QUERY_KEY_NAMESPACE, 'messageTemplateMeta'],
    queryFn: async () => {
      const response = await fetchMessageTemplateMeta();

      try {
        const parsed = MessageTemplateMetaSchema.shape.messageCategories.parse(
          response.messageCategories,
        );

        return parsed;
      } catch (err) {
        console.error(err);

        return [];
      }
    },
  });

  return query;
}

// TODO 這個要串回 settings 嗎？但其實根本不會吃，最後沒有就刪掉
export function useMessageActionType() {
  const query = useQuery({
    queryKey: [MESSAGE_QUERY_KEY_NAMESPACE, 'messageTemplateMeta'],
    queryFn: async () => {
      const response = await fetchMessageTemplateMeta();

      try {
        const parsed = z
          .array(MessageTemplateMetaSchema.shape.actions)
          .parse(response.actions);

        return { messageCategories: parsed };
      } catch (err) {
        console.error(err);

        return { messageCategories: [] };
      }
    },
  });

  return query;
}
